import { ChevronLeft, ChevronRight } from 'lucide-react'

const MONTHS = [
    'Január',
    'Február',
    'Március',
    'Április',
    'Május',
    'Június',
    'Július',
    'Augusztus',
    'Szeptember',
    'Október',
    'November',
    'December',
]

type MonthCalendarProps = {
    displayYear: number
    selectedYear: number
    selectedMonth: number | null
    monthlyCounts?: { month: number; count: number }[]
    onChangeDisplayYear: (year: number) => void
    onSelectMonth: (year: number, month: number) => void
}

export const MonthCalendar = ({
    displayYear,
    selectedYear,
    selectedMonth,
    monthlyCounts,
    onChangeDisplayYear,
    onSelectMonth,
}: MonthCalendarProps) => {
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth()

    const isSelected = (month: number) => displayYear === selectedYear && month === selectedMonth

    const isCurrent = (month: number) => displayYear === currentYear && month === currentMonth

    return (
        <div className="w-full rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
            <div className="mb-6 flex items-center justify-between">
                <button
                    className="flex h-9 w-9 items-center justify-center rounded-full text-brand-gray transition-colors hover:bg-slate-100 hover:text-brand-dark"
                    onClick={() => onChangeDisplayYear(displayYear - 1)}
                >
                    <ChevronLeft className="h-5 w-5" />
                </button>
                <span className="text-lg font-bold text-brand-dark">{displayYear}</span>
                <button
                    className="flex h-9 w-9 items-center justify-center rounded-full text-brand-gray transition-colors hover:bg-slate-100 hover:text-brand-dark"
                    onClick={() => onChangeDisplayYear(displayYear + 1)}
                >
                    <ChevronRight className="h-5 w-5" />
                </button>
            </div>
            <div className="grid grid-cols-3 gap-2">
                {MONTHS.map((name, index) => {
                    const count = monthlyCounts?.[index]?.count ?? 0

                    return (
                        <button
                            key={name}
                            className={`relative min-w-0 truncate rounded-xl px-1.5 pb-5 pt-3 text-xs font-medium transition-all ${
                                isSelected(index)
                                    ? 'bg-primary text-white shadow-sm'
                                    : isCurrent(index)
                                      ? 'bg-primary/10 font-semibold text-primary hover:bg-primary/20'
                                      : 'text-brand-gray hover:bg-slate-50 hover:text-brand-dark'
                            }`}
                            onClick={() => onSelectMonth(displayYear, index)}
                        >
                            {name}
                            {count > 0 && (
                                <span
                                    className={`absolute bottom-1 right-1 flex h-4 min-w-[16px] items-center justify-center rounded-full px-1 text-[10px] font-bold ${
                                        isSelected(index)
                                            ? 'bg-white text-primary'
                                            : 'bg-primary/10 text-primary'
                                    }`}
                                >
                                    {count}
                                </span>
                            )}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
